import React, {useEffect} from "react"

import { AppAntSwitch } from "@components"
import {markets, siteMarket, sites} from "@signals"
import {batch} from "@preact/signals-react";


export default function AppCommonFiltersSiteMarketToggleButton({ ...props }) {

    useEffect(() => batch(() => {
        sites.value = []
        markets.value = []
    }), [siteMarket.value]);

    return <AppAntSwitch
        falseText="Site"
        trueText="Market"
        checked={siteMarket.value}
        onChange={newValue => siteMarket.value = newValue.target.checked}
        {...props}
    />
}